import React, { createContext, useState } from 'react'

export const ThemeContext = createContext()

const ThemeProvider = ({ scrollSmoother, children }) => {
  const [showSplash, setShowSplash] = useState(true)

  return (
    <ThemeContext.Provider
      value={{
        showSplash,
        setShowSplash,
        scrollSmoother
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
